<template>
  <div class="container-fluid">
    <!-- Contract Header -->
    <HeaderContract
      :contract="model_contract"
      :filter-date.sync="filter_date"
      :employees="modelContractEmployees"
    />

    <!-- Content -->
    <div class="row">
      <!-- Calendar -->
      <div class="col-lg-9">
        <div class="card">
          <div class="card-header d-flex justify-content-between">
            <div>
              <!-- <i class="ti ti-calendar-event text-primary mr-2"></i> -->
              📅 <span>Shift Calendar</span>
            </div>
          </div>

          <div class="card-body">
            <div v-if="selectedEmployee">
              <div class="calendar-toolbar mb-3">
                <div class="row">
                  <div class="col-md-4">
                    <label>Shift Pattern</label>

                    <select class="form-control" v-model="selectedPattern">
                      <option value="">Select Pattern</option>

                      <option
                        v-for="(shift, index) in model_shift_hour"
                        :key="shift.name + '-' + shift.hour + '-' + index"
                        :value="shift.name + ' - ' + shift.hour"
                      >
                        {{ shift.name }} - {{ shift.hour }}
                      </option>

                      <option value="OFF">OFF</option>

                      <option value="O">O</option>
                    </select>
                  </div>

                  <div class="col-md-4">
                    <!-- <label>Apply To</label>

                    <select class="form-control" v-model="applyType">
                      <option value="week">Current Week</option>
                      <option value="month">Entire Month</option>
                    </select> -->
                  </div>

                  <div class="col-md-4 d-flex align-items-end">
                    <button
                      class="btn btn-success btn-block"
                      @click="applyPattern"
                    >
                      Apply Pattern
                    </button>
                  </div>

                  <div class="col-md-12">
                    <div class="mt-2">
                      <div class="alert alert-info py-2 mb-3">
                        <i class="ti-info-alt mr-2"></i>

                        <b>Informasi</b>

                        <br />

                        Shift Pattern hanya diterapkan pada minggu yang dipilih.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="selectedDate" class="selected-date-toolbar mb-3">
                <div class="selected-date-info">
                  <i class="ti-pencil-alt"></i>

                  <div>
                    <small>Editing Schedule</small>

                    <strong>{{ selectedDate.date }}</strong>
                  </div>
                </div>

                <div class="selected-date-action">
                  <select
                    class="form-control"
                    :value="selectedDate.shift"
                    @change="changeSelectedDateShift($event)"
                  >
                    <option
                      v-for="(shift, index) in model_shift_hour"
                      :key="shift.name + '-' + index"
                      :value="shift.name + ' - ' + shift.hour"
                    >
                      {{ shift.name }} - {{ shift.hour }}
                    </option>

                    <option value="OFF">OFF</option>

                    <option value="O">O</option>
                  </select>
                </div>
              </div>

              <div class="alert alert-warning" v-if="hasPendingChanges">
                <div class="d-flex justify-content-between align-items-center">
                  <span> You have unsaved changes. </span>
                  <div>
                    <button
                      class="btn btn-success btn-sm mr-2"
                      @click="savePendingChanges"
                    >
                      Save
                    </button>

                    <button
                      class="btn btn-secondary btn-sm"
                      @click="cancelPendingChanges"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
              <div class="calendar-header">
                <div class="week-header">Week</div>
                <div
                  v-for="day in weekDays"
                  :key="day"
                  class="calendar-weekday"
                >
                  {{ day }}
                </div>
              </div>

              <div
                class="calendar-week"
                v-for="(week, indexWeek) in calendarWeeks"
                :key="indexWeek"
              >
                <!-- Week Action -->

                <div
                  class="week-action"
                  :class="{
                    active: selectedWeekIndex === indexWeek,
                  }"
                  @click="selectWeek(indexWeek)"
                >
                  <button
                    class="week-menu-button"
                    @click.stop="toggleWeekMenu(indexWeek)"
                  >
                    <i class="ti-more-alt"></i>
                  </button>

                  <small> W{{ indexWeek + 1 }} </small>

                  <div
                    v-if="activeWeekMenu === indexWeek"
                    class="week-dropdown"
                    @click.stop
                  >
                    <a @click="copyWeek(indexWeek)">
                      <i class="ti-files"></i>
                      Copy Week
                    </a>

                    <a v-if="clipboardWeek" @click="pasteWeek(indexWeek)">
                      <i class="ti-clipboard"></i>
                      Paste Here
                    </a>

                    <a class="text-danger" @click="clearWeek(indexWeek)">
                      <i class="ti-trash"></i>
                      Clear Week
                    </a>
                  </div>
                </div>

                <!-- Calendar -->

                <div
                  class="calendar-cell"
                  v-for="(item, indexDay) in week"
                  :key="indexDay"
                  :class="{
                    empty: !item,
                    selected:
                      selectedDate && item && selectedDate.date == item.date,
                  }"
                  @click="item && selectDate(item)"
                >
                  <span
                    v-if="
                      selectedDate && item && selectedDate.date === item.date
                    "
                    class="editing-badge"
                  >
                    <i class="ti-pencil"></i> Editing
                  </span>
                  <template v-if="item">
                    <div class="calendar-date">
                      {{ item.day }}
                    </div>

                    <div
                      class="calendar-shift"
                      :class="GetShiftClass(item.shift)"
                    >
                      {{ item.shift }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Employee -->
      <div class="col-lg-3">
        <PeriodPanel
          v-model="filter_date"
          :disabled-date="disabledBeforeAfterFilterDate"
          @change="FilterModelDate"
        />
        <TechnicianPanel
          :employees="modelContractEmployees"
          :selected="selectedEmployee"
          @select="selectEmployee"
        />
      </div>
    </div>

    <!-- Modal -->
    <!-- Pending Dialog -->
    <div v-if="showPendingDialog" class="pending-backdrop">
      <div class="pending-dialog">
        <h5 class="mb-3">Perubahan Belum Disimpan</h5>

        <div class="alert alert-light mt-3">
          <template v-if="pendingNavigation.type === 'employee'">
            <strong>Tujuan :</strong>

            Teknisi

            <strong>{{ pendingNavigation.employee.firstname }}</strong>
          </template>

          <template v-else-if="pendingNavigation.type === 'period'">
            <strong>Tujuan :</strong>

            Periode

            <strong>{{ pendingNavigation.period }}</strong>
          </template>
        </div>

        <div class="text-right">
          <button class="btn btn-light mr-2" @click="stayHere">
            Tetap Disini
          </button>

          <button class="btn btn-warning mr-2" @click="cancelAndSwitch">
            Batalkan Perubahan
          </button>

          <button class="btn btn-success" @click="confirmSaveAndSwitch">
            Simpan & Pindah
          </button>
        </div>
      </div>
    </div>
    <!-- End Modal -->
  </div>
</template>
<script>
import axios from "axios";

import { ContentLoader, ListLoader } from "vue-content-loader";
import HeaderContract from "./components/HeaderContract.vue";
import PeriodPanel from "./components/PeriodPanel.vue";
import TechnicianPanel from "./components/TechnicianPanel.vue";

export default {
  components: {
    ContentLoader,
    ListLoader,
    HeaderContract,
    PeriodPanel,
    TechnicianPanel,
  },
  data() {
    return {
      isLoading: true,
      calendarWeeks: [],
      calendarOriginal: [],
      meta_url: "shiftwork",
      page: 1,
      collection_month: [],
      dateNowProject: null,
      modelContractEmployee_lastpage: 0,
      modelContractEmployee_frompage: 0,
      isUpdateTools: false,
      model_contract: {},
      modelContractEmployees: [],
      selectedEmployee: null,
      shiftwork_employee: [],
      shiftwork_employee_loading: false,
      model_shift_hour: [],
      shift_last_updated: "",
      filter_date: "",
      filter_month: "",
      filter_year: "",
      selectedPattern: "",
      applyType: "week",
      selectedDate: null,
      selectedWeekIndex: null,
      clipboardWeek: null,
      selectedWeek: null,
      hasPendingChanges: false,
      pendingChanges: {},
      activeWeekMenu: null,
      showPendingDialog: false,
      pendingNavigation: {
        type: null, // employee | period
        employee: null,
        period: null,
      },
      nextEmployee: null,
    };
  },
  computed: {
    weekDays() {
      return ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    },
  },
  mounted() {
    this.QueryStartFromPeriod();

    document.addEventListener("click", () => {
      this.activeWeekMenu = null;
    });
  },
  watch: {
    shiftwork_employee() {
      this.generateCalendar();
    },
    selectedEmployee(newVal) {
      if (!newVal) return;

      this.getShiftWorkPerMonthByNik(newVal.nik);
    },
  },

  methods: {
    disabledBeforeAfterFilterDate(date) {
      const start_date = new Date(this.model_contract.start_date);
      start_date.setHours(0, 0, 0, 0);

      const end_date = new Date(this.model_contract.end_date);
      end_date.setHours(0, 0, 0, 0);

      let dateNow = new Date(date.getFullYear(), date.getMonth());
      let dateStart = new Date(start_date.getFullYear(), start_date.getMonth());
      let dateEnd = new Date(end_date.getFullYear(), end_date.getMonth());

      return dateNow < dateStart || dateNow > dateEnd;
    },
    changePeriod() {
      let fdate = this.filter_date.split("/");

      this.filter_month = fdate[0];
      this.filter_year = fdate[1];

      this.DataQuery();
    },
    FilterModelDate() {
      if (this.hasPendingChanges) {
        this.pendingNavigation = {
          type: "period",
          employee: null,
          period: this.filter_date,
        };

        this.showPendingDialog = true;

        return;
      }

      this.changePeriod();
    },
    async QueryStartFromPeriod() {
      await axios
        .get("contract/period/" + localStorage.getItem("QUERY_ID"))
        .then((response) => {
          const d = new Date();
          let query = response.data;
          let default_date = query.default;

          var dt = default_date.split("/");

          // this.collection_month = query.month_period;
          this.filter_month = ("0" + (d.getMonth() + 1)).slice(-2);
          this.filter_year = d.getFullYear().toString();

          this.filter_date = this.filter_month + "/" + this.filter_year;

          this.DataQuery();
        })
        .catch((error) => {
          console.log(error.statusText);
        })
        .finally(() => {
          // this.$store.state.loading.status = false;
        });
    },
    async DataQuery() {
      this.isLoading = true;
      this.opened = [];
      await axios
        .post("shiftwork/contract-v2", {
          id_contract: localStorage.getItem("QUERY_ID"),
          month: this.filter_month,
          year: this.filter_year,
        })
        .then((response) => {
          let query = response.data;

          // console.log(query);

          // this.dateNowProject = query.date;
          this.model_contract = query.contract;
          this.shift_last_updated = query.shift_last_updated.updated_at;
          this.model_shift_hour = query.shift_hour;
          //   console.log(JSON.stringify(this.model_shift_hour));

          // enable tools
          let block_status = ["terminate", "out_of_date"];
          if (!block_status.includes(this.model_contract.status)) {
            this.isUpdateTools = true;
          }

          // Add Default Shift
          if (!this.model_shift_hour) {
            this.model_shift_hour = new Array();
            this.model_shift_hour.push({ hour: "--:--", name: "Absent" });
          }

          // console.log(this.model_shift_hour);

          this.getEmployeeContractShiftWork();
          // this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          // this.$store.state.loading.status = false;
        });
    },
    // async getEmployeeContractShiftWork(pageNum = 1) {
    //   this.isLoading = true;
    //   this.page = pageNum;
    //   await axios
    //     .post("shiftwork/employee-v2?page=" + this.page, {
    //       id_contract: localStorage.getItem("QUERY_ID"),
    //       month: this.filter_month,
    //       year: this.filter_year,
    //     })
    //     .then((response) => {
    //       let query = response.data.result;

    //       this.modelContractEmployees = query.data;
    //       this.modelContractEmployee_lastpage = query.last_page;
    //       this.modelContractEmployee_frompage = query.from;

    //       this.restoreSelectedEmployee();

    //       this.isLoading = false;
    //     })
    //     .catch((error) => {
    //       console.log(error.statusText);
    //     });
    // },
    async getEmployeeContractShiftWork(pageNum = 1) {
      this.isLoading = true;

      this.page = pageNum;

      try {
        const response = await axios.post(
          "shiftwork/employee-v2?page=" + this.page,
          {
            id_contract: localStorage.getItem("QUERY_ID"),
            month: this.filter_month,
            year: this.filter_year,
          }
        );

        let query = response.data.result;

        this.modelContractEmployees = query.data;

        this.modelContractEmployee_lastpage = query.last_page;

        this.modelContractEmployee_frompage = query.from;

        this.restoreSelectedEmployee();
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    restoreSelectedEmployee() {
      if (!this.selectedEmployee) {
        if (this.modelContractEmployees.length > 0) {
          const employee = this.modelContractEmployees[0];

          this.selectedEmployee = employee;

          this.getShiftWorkPerMonthByNik(employee.nik);
        }

        return;
      }

      const employee = this.modelContractEmployees.find(
        (x) => x.nik === this.selectedEmployee.nik
      );

      if (!employee) {
        this.selectedEmployee = null;
        this.calendarWeeks = [];
        this.selectedDate = null;

        return;
      }

      this.selectedEmployee = employee;

      this.getShiftWorkPerMonthByNik(employee.nik);
    },
    selectEmployee(item) {
      // klik teknisi yang sama
      if (this.selectedEmployee && this.selectedEmployee.nik === item.nik) {
        return;
      }

      // ada perubahan
      // if (this.hasPendingChanges) {
      //   this.nextEmployee = item;

      //   this.showPendingDialog = true;

      //   return;
      // }
      if (this.hasPendingChanges) {
        this.pendingNavigation = {
          type: "employee",
          employee: item,
          period: null,
        };

        this.showPendingDialog = true;
        return;
      }

      this.selectedEmployee = item;
    },
    loadSelectedEmployeeCalendar() {
      if (!this.selectedEmployee) return;

      this.getShiftWorkPerMonthByNik(this.selectedEmployee.nik);
    },
    async getShiftWorkPerMonthByNik(nik) {
      this.shiftwork_employee_loading = true;
      this.shiftwork_employee = [];
      await axios
        .post("shiftwork/date-range-v2", {
          id_contract: localStorage.getItem("QUERY_ID"),
          month: this.filter_month,
          year: this.filter_year,
          nik: nik,
        })
        .then((response) => {
          let res = response.data.result;
          setTimeout(() => {
            this.shiftwork_employee = res.date_range_shiftwork;
            // console.log(JSON.stringify(this.shiftwork_employee));
            this.shiftwork_employee_loading = false;
          }, 1000);
        })
        .catch((error) => {
          // console.log(error.response);
          let err = error.response;
          alert(err.data.msg);
          // this.loading_shiftwork_employee = false;
        });
    },
    GetShiftClass(shift) {
      switch (shift) {
        case "OFF":
          return "shift-off";
        case "O":
          return "shift-o";
        case "Absent":
          return "shift-absent";
        default:
          return "shift-normal";
      }
    },
    generateCalendar() {
      if (!this.shiftwork_employee.length) {
        this.calendarWeeks = [];
        return;
      }

      const year = Number(this.filter_year);
      const month = Number(this.filter_month);

      const firstDate = new Date(year, month - 1, 1);

      let firstDay = firstDate.getDay();

      // Monday First
      firstDay = firstDay === 0 ? 6 : firstDay - 1;

      const calendar = [];

      let week = [];

      // padding minggu pertama

      for (let i = 0; i < firstDay; i++) {
        week.push(null);
      }

      // isi tanggal

      this.shiftwork_employee.forEach((day) => {
        week.push(day);

        if (week.length === 7) {
          calendar.push(week);

          week = [];
        }
      });

      // padding minggu terakhir

      while (week.length < 7 && week.length > 0) {
        week.push(null);
      }

      if (week.length) {
        calendar.push(week);
      }

      //   this.calendarWeeks = calendar;
      this.setCalendar(calendar);
    },
    selectDate(item) {
      this.selectedDate = item;

      this.selectedWeekIndex = this.getSelectedWeekIndex();
    },
    selectWeek(index) {
      this.selectedWeekIndex = index;
    },
    getWeek(index) {
      return this.calendarWeeks[index] || [];
    },
    getValidDaysInWeek(index) {
      return this.calendarWeeks[index].filter((day) => day);
    },
    getSelectedWeekIndex() {
      if (!this.selectedDate) return -1;

      return this.calendarWeeks.findIndex((week) =>
        week.some((day) => day && day.date === this.selectedDate.date)
      );
    },
    copyWeek(index) {
      this.clipboardWeek = JSON.parse(
        JSON.stringify(this.calendarWeeks[index])
      );

      this.activeWeekMenu = null;

      this.$store.state.alert.status = true;
      this.$store.state.alert.type = "success";
      this.$store.state.alert.msg = "Week copied.";
    },
    pasteWeek(index) {
      if (!this.clipboardWeek) return;

      const target = this.calendarWeeks[index];

      this.clipboardWeek.forEach((source, i) => {
        if (!source || !target[i]) return;

        this.updateCalendarShift(
          target[i],

          source.shift
        );
      });
    },
    clearWeek(index) {
      const week = this.getValidDaysInWeek(index);

      week.forEach((day) => {
        this.updateCalendarShift(day, "O");
      });

      this.activeWeekMenu = null;
    },
    toggleWeekMenu(index) {
      if (this.activeWeekMenu === index) {
        this.activeWeekMenu = null;

        return;
      }

      this.activeWeekMenu = index;
    },
    cancelPendingChanges() {
      this.pendingChanges = [];
      this.hasPendingChanges = false;
      this.getShiftWorkPerMonthByNik(this.selectedEmployee.nik);
    },
    splitShift(value) {
      if (value === "OFF" || value === "O") {
        return {
          shift: value,
          hour: null,
        };
      }

      const arr = value.split(" - ");

      return {
        shift: arr[0].trim(),
        hour: arr[1].trim(),
      };
    },
    async savePendingChanges() {
      const schedule = Object.values(this.pendingChanges).map((item) => {
        const shift = this.splitShift(item.newShift);

        return {
          id: item.id,
          nik: item.nik,
          date: item.date,
          shift: shift.shift,
          hour: shift.hour,
        };
      });

      const payload = {
        id_contract: localStorage.getItem("QUERY_ID"),
        schedule,
      };

      try {
        const response = await axios.post("shiftwork/assign-v2.2", payload);

        this.pendingChanges = {};
        this.hasPendingChanges = false;

        this.calendarOriginal = JSON.parse(JSON.stringify(this.calendarWeeks));

        this.$store.state.alert.status = true;
        this.$store.state.alert.type = "success";
        this.$store.state.alert.msg = response.data.msg;
      } catch (error) {
        console.error(error);

        this.$store.state.alert.status = true;
        this.$store.state.alert.type = "trash";
        if (error.response && error.response.data) {
          this.$store.state.alert.msg = error.response.data.msg;
        } else {
          this.$store.state.alert.msg = "Gagal menyimpan perubahan.";
        }
        return false;
      }

      return true;
    },
    async confirmSaveAndSwitch() {
      const success = await this.savePendingChanges();

      if (!success) return;

      // this.selectedEmployee = this.nextEmployee;

      if (this.pendingNavigation.type === "employee") {
        this.selectedEmployee = this.pendingNavigation.employee;
      }

      if (this.pendingNavigation.type === "period") {
        this.changePeriod();
      }

      this.pendingNavigation = {
        type: null,
        employee: null,
        period: null,
      };

      // this.nextEmployee = null;

      this.showPendingDialog = false;
    },
    cancelAndSwitch() {
      this.cancelPendingChanges();

      // this.selectedEmployee = this.nextEmployee;

      if (this.pendingNavigation.type === "employee") {
        this.selectedEmployee = this.pendingNavigation.employee;
      }

      if (this.pendingNavigation.type === "period") {
        this.changePeriod();
      }

      this.pendingNavigation = {
        type: null,
        employee: null,
        period: null,
      };

      this.showPendingDialog = false;

      // this.nextEmployee = null;

      // this.showPendingDialog = false;
    },
    stayHere() {
      // this.nextEmployee = null;

      this.pendingNavigation = {
        type: null,
        employee: null,
        period: null,
      };

      this.showPendingDialog = false;
    },
    setCalendar(calendar) {
      this.calendarOriginal = JSON.parse(JSON.stringify(calendar));
      this.calendarWeeks = calendar;
    },
    updatePendingChange(item, newShift) {
      if (!item) return;

      const key = item.date;

      const original = this.calendarOriginal
        .flat()
        .find((x) => x && x.date === key);

      if (!original) return;

      // Jika shift kembali seperti awal
      if (original.shift === newShift) {
        delete this.pendingChanges[key];
      } else {
        this.pendingChanges[key] = {
          id: item.id,
          date: item.date,
          nik: this.selectedEmployee.nik,
          oldShift: original.shift,
          newShift: newShift,
          status: item.status,
        };
      }

      this.hasPendingChanges = Object.keys(this.pendingChanges).length > 0;
    },
    updateCalendarShift(item, newShift) {
      if (!item) return;

      // Tidak ada perubahan
      if (item.shift === newShift) {
        return;
      }

      // Update UI
      item.shift = newShift;

      if (this.selectedDate && this.selectedDate.date === item.date) {
        this.selectedDate.shift = newShift;
      }

      // Update Pending
      this.updatePendingChange(item, newShift);
    },
    changeSelectedDateShift(event) {
      if (!this.selectedDate) return;

      this.updateCalendarShift(this.selectedDate, event.target.value);
    },
    applyPattern() {
      if (!this.selectedPattern) {
        this.$store.state.alert.status = true;
        this.$store.state.alert.type = "warning";
        this.$store.state.alert.msg = "Please select shift pattern.";

        return;
      }

      if (!this.selectedDate) {
        this.$store.state.alert.status = true;
        this.$store.state.alert.type = "warning";
        this.$store.state.alert.msg = "Please select date.";

        return;
      }

      // const shift = this.formatShift(this.selectedPattern);
      const shift = this.selectedPattern;

      if (this.applyType === "week") {
        const weekIndex = this.getSelectedWeekIndex();

        if (weekIndex === -1) return;

        this.getValidDaysInWeek(weekIndex).forEach((day) => {
          this.updateCalendarShift(day, shift);
        });
      }
    },
  },
};
</script>


<style scoped>
.card {
  border-radius: 12px;
}

.card-header {
  background: #fff;
  font-weight: 600;
}

.calendar-placeholder {
  height: 650px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed #d9d9d9;
  border-radius: 12px;
  color: #999;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  gap: 12px;
}

.calendar-header {
  display: grid;
  grid-template-columns: 80px repeat(7, 1fr);
  gap: 10px;
  margin-bottom: 10px;
}

.calendar-weekday {
  text-align: center;
  font-weight: 700;
  padding: 10px;
  background: #f8f9fa;
  border: 1px solid #ececec;
}

.calendar-week {
  display: grid;
  grid-template-columns: 80px repeat(7, 1fr);
  gap: 10px;
  margin-bottom: 10px;
}

.selected-date-toolbar {
  display: flex;

  align-items: center;

  justify-content: space-between;

  background: #f8fbff;

  border: 1px solid #dbeafe;

  border-radius: 10px;

  padding: 12px 16px;
}

.selected-date-info {
  display: flex;

  align-items: center;
}

.selected-date-info i {
  font-size: 18px;

  color: #0d6efd;

  margin-right: 12px;
}

.selected-date-info small {
  display: block;

  color: #888;
}

.selected-date-info strong {
  font-size: 15px;
}

.selected-date-action {
  width: 260px;
}

.week-menu {
  position: fixed;
  width: 180px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
  z-index: 99999;
}

.week-menu-item {
  padding: 12px 15px;
  cursor: pointer;
}

.week-menu-item:hover {
  background: #f5f5f5;
}

.week-column {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  background: #f8f9fa;
  border: 1px solid #ececec;
  border-radius: 8px;
}

.week-action {
  position: relative;
  border: 1px solid #ececec;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  min-height: 120px;
}

.week-action:hover {
  border-color: #007bff;
  background: #eef6ff;
}

.week-action.active {
  border: 2px solid #28a745;
  background: #f1fbf4;
}

.week-action.active small {
  color: #28a745;
  font-weight: bold;
}

.week-menu-button {
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
  margin-bottom: 8px;
}

.week-dropdown {
  position: absolute;
  top: 35px;
  left: 70px;
  width: 180px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: hidden;
}

.week-dropdown a {
  display: block;
  padding: 12px;
  cursor: pointer;
  color: #333;
  text-decoration: none;
}

.week-dropdown a:hover {
  background: #f5f7fa;
}

.calendar-cell {
  min-height: 120px;
  border: 1px solid #ececec;
  border-radius: 10px;
  padding: 10px;
  background: #fff;
  transition: 0.2s;

  position: relative;
}

.editing-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #777;
  color: white;
  font-size: 10px;
  padding: 3px 8px;
  border-radius: 30px;
  font-weight: 600;
}

.calendar-cell:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.calendar-cell.selected {
  border: 2px solid #0d6efd;
  background: #f8fbff;
  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.12);
}

.calendar-cell.selected .calendar-shift {
  transform: scale(1.05);
  font-weight: bold;
}

.calendar-cell.empty {
  border: none;
  background: transparent;
  box-shadow: none;
}

.calendar-date {
  font-size: 20px;
  font-weight: bold;
}

.calendar-shift {
  margin-top: 15px;
  text-align: center;
  border-radius: 20px;
  padding: 6px;
  font-weight: 600;
}

.calendar-item {
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 10px;
  text-align: center;
  transition: 0.2s;
}

.calendar-item:hover {
  border-color: #0d6efd;
  transform: translateY(-2px);
}
.calendar-day {
  font-size: 22px;
  font-weight: 700;
}
.calendar-week {
  font-size: 12px;
  color: #777;
  margin-bottom: 10px;
}
.calendar-shift {
  border-radius: 20px;
  padding: 4px;
  font-size: 12px;
  font-weight: 600;
}
.shift-normal {
  background: #e8f5e9;
  color: #2e7d32;
}

.shift-off {
  background: #ffebee;
  color: #d32f2f;
}

.shift-o {
  background: #fff8e1;
  color: #f57f17;
}

.shift-absent {
  background: #eceff1;
  color: #455a64;
}

.pending-backdrop {
  position: fixed;

  inset: 0;

  background: rgba(0, 0, 0, 0.45);

  display: flex;

  justify-content: center;

  align-items: center;

  z-index: 99999;
}

.pending-dialog {
  width: 500px;
  background: #fff;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
}
</style>